import {capitaliseFirst, you} from "./__strings"
import PropTypes from "prop-types";
import {intervalToDuration} from "date-fns";

export default function personal(props) {
    const betterProps = {...props, ...{you: you(props.applicant === 1 ? false : props.mortgage.applicant2?.firstName ? props.mortgage.applicant2.firstName:'the other applicant')}}
    return {
        name: `personal-${props.applicant}`,
        title: 'Personal details',
        personalisedTitle: capitaliseFirst(betterProps.you.your) + ' personal details',
        link: `apply-${props.applicant}/personal`,
        props: props,
        questions: [
            firstName(betterProps),
            surname(betterProps),
            isMale(betterProps),
            title(betterProps),
            maritalStatus(betterProps),
            maidenName(betterProps),
            dateOfBirth(betterProps),
            countDependents(betterProps),
            dependentAges(betterProps),
            //TODO: Add Do you have any child-minding costs?
            hasChildcareCosts(betterProps),
            monthlyChildcareCosts(betterProps),
            accommodationSituation(betterProps),
            accommodationSituationOther(betterProps),
            contributeToRelatives(betterProps),
            monthlyAccommodationCosts(betterProps),
            monthlyRentCosts(betterProps),
            addressCurrent(betterProps),
            //TODO: Change to MM/YYYY type When did you move in
            addressCurrentStartDate(betterProps),
            addressPrevious(betterProps),
            nationality(betterProps),
            countryOfResidence(betterProps),
            countryOfBirth(betterProps),
            placeOfBirth(betterProps),
            negativeCredit(betterProps)
        ]
    }
}

export function isMale(props) {
    return {
        label: "Gender",
        text: "What is " + props.you.your + " gender?",
        name: "isMale",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Female",
                    value: false
                },
                {
                    text: "Male",
                    value: true
                }
            ]
        },
        model: "applicant"
    }
}
export function firstName(props) {
    return {
        label: "First Name",
        text: "What is " + props.you.your + " first name?",
        name: "firstName",
        answer: {
            type: "text",
        },
        model: "applicant"
    }
}
export function surname(props) {
    return {
        label: "Surname",
        text: "What is " + props.you.your + " surname?",
        name: "surname",
        answer: {
            type: "text",
        },
        model: "applicant"
    }
}
export function addressCurrent(props) {
    return {
        label: "Home Address",
        text: "What is " + props.you.your + " home address?",
        name: "addressCurrent",
        answer: {
            type: "address"
        },
        model: "personal"
    }
}
export function addressCurrentYears(props) {
    return {
        label: "Years At Address",
        text: "For how many years " + props.you.haveYou + " lived here?",
        name: "addressCurrentYears",
        answer: {
            type: "int",
            validation: {
                min: {value: 0, message:'The minimum value here is 0'},
                max: {value: 67, message: "Max value exceeded"}
            }
        },
        model: "personal"
    }
}
export function addressCurrentStartDate(props) {

    return {
        label: "Moved In",
        text: "Since what date " + props.you.haveYou + " lived here?",
        name: "addressCurrentStartDate",
        answer: {
            type: "mmyyyy",
            validation: {
                max: {value: new Date() , message:'Date cannot be in the future'},
            }
        },
        model: "personal"
    }
}
export function addressPrevious(props) {
    return {
        label: "Previous Address",
        text: "What was " + props.you.your + " previous address?",
        name: "addressPrevious",
        answer: {
            type: "address"
        },
        hides: {
            addressCurrentStartDate: (v) => {
                if (v){
                    let o = intervalToDuration({
                        start: new Date(),
                        end: new Date(v)
                    })
                    return o.years >= 2
                }

            }
        },
        model: "personal"
    }
}
export function dependentAges(props) {
    return {
        label: "Children Ages",
        text: "What are their ages?",
        name: "dependentAges",
        answer: {
            type: "agearray",
        },
        hides: {
            countDependents: (v) => {
                return parseInt(v) === 0 || isNaN(parseInt(v))
            }
        },
        model: "personal"
    }
}
export function title(props) {
    return {
        label: "Title",
        text: "What title " + props.you.doYou + " use?",
        name: "title",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Mr",
                    value: "MR"
                },
                {
                    text: "Mrs",
                    value: "MRS"
                },
                {
                    text: "Miss",
                    value: "MISS"
                },
                {
                    text: "Dr",
                    value: "DR"
                }
            ]
        },
        model: "personal"
    }
}
export function maidenName(props) {
    return {
        label: "Maiden Name",
        text: "What is " + props.you.your + " maiden name?",
        name: "maidenName",
        answer: {
            type: "text"
        },
        hides: {
            maritalStatus: (v) => {
                return ["SINGLE", "COHABITING"].includes(v)
            },
            isMale: (v) => {
                return v === true
            }
        },
        model: "personal"
    }
}
export function accommodationSituation(props) {
    return {
        label: "Home Situation",
        text: "What best describes " + props.you.your + " living situation?",
        name: "accommodationSituation",
        answer: {
            type: "choice",
            choices: [
                {
                    text: props.you.i + " own" + (props.you.i === "I" ? "" : "s") + " the home",
                    value: "OWNED"
                },
                {
                    text: props.you.i + " rent" + (props.you.i === "I" ? "" : "s") + " the home",
                    value: "RENTED"
                },
                {
                    text: props.you.i + " live" + (props.you.i === "I" ? "" : "s") + " with relatives",
                    value: "RELATIVES"
                },
                {
                    text: "Other",
                    value: "OTHER"
                }
            ]
        },
        model: "personal"
    }
}
export function accommodationSituationOther(props) {
    return {
        label: "Living Situation",
        text: "Provide more details about " + props.you.your + " living situation?",
        name: "accommodationSituationOther",
        answer: {
            type: "textarea"
        },
        hides: {
            accommodationSituation: (v) => {
                return v !== "OTHER"
            }
        },
        model: "personal"
    }
}
export function dateOfBirth(props) {
    return {
        label: "Date of Birth",
        text: "What is " + props.you.your + " date of birth?",
        name: "dateOfBirth",
        answer: {
            type: "ddmmyyyy",
            validation: (value)=>{
                const now = new Date();
                const min = now.getDate() + " / " + now.getMonth() + 1 + " / " + (now.getFullYear() - 66)
                const max = now.getDate() + " / " + now.getMonth() + 1 + " / " + (now.getFullYear() - 18)
                const test = new Date(value)
                if (test.getTime() > max.getTime) return 'You must be younger than 66 to use this service'
                if (test < min) return 'You must be over 18 to use this service'
                return false
            }
        },
        model: "personal"
    }
}
export function maritalStatus(props) {
    return {
        label: "Marital Status",
        text: "What is " + props.you.your + " marital status?",
        name: "maritalStatus",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Single",
                    value: "SINGLE"
                },
                {
                    text: "Cohabiting",
                    value: "COHABITING"
                },
                {
                    text: "Married",
                    value: "MARRIED"
                },
                {
                    text: "Re-married",
                    value: "REMARRIED"
                },
                {
                    text: "Separated",
                    value: "SEPARATED"
                },
                {
                    text: "Divorced",
                    value: "DIVORCED"
                },
                {
                    text: "Widowed",
                    value: "WIDOWED"
                }

            ]
        },
        model: "personal"
    }
}
export function countryOfBirth(props) {
    return {
        label: "Country of Birth",
        text: "What is " + props.you.your + " country of birth?",
        name: "countryOfBirth",
        answer: {
            type: "country"
        },
        model: "personal"
    }
}
export function countryOfResidence(props) {
    return {
        name: "countryOfResidence",
        label: "Country of Residence",
        text: "In what country " + props.you.doYou + " reside?",
        answer: {
            type: "country"
        },
        model: "personal"
    }
}
export function countDependents(props) {
    return {
        label: "Number Dependents",
        text: "How many dependent children " + props.you.doYou.toString() + " have?",
        name: "countDependents",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "None",
                    value: 0
                }, {
                    text: "One",
                    value: 1
                },
                {
                    text: "Two",
                    value: 2
                },
                {
                    text: "Three",
                    value: 3
                },
                {
                    text: "Four",
                    value: 4
                },
                {
                    text: "Five",
                    value: 5
                },
                {
                    text: "Six",
                    value: 6
                }
            ]
        },
        model: "personal"
    }
}
export function nationality(props) {
    return {
        label: "Nationality",
        text: "What is " + props.you.your + " nationality?",
        name: "nationality",
        answer: {
            type: "nationality"
        },
        model: "personal"
    }
}
export function negativeCredit(props) {
    return {
        name: "negativeCredit",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Negative Credit",
        text: capitaliseFirst(props.you.haveYou) + " ever been made bankrupt, made any arrangements with creditors, had any court judgements for debt made against you or been in arrears with any existing or previous loan?",
        model: "financial"
    }
}
export function contributeToRelatives(props) {
    return {
        text: capitaliseFirst(props.you.doYou) + " contribute anything towards " + props.you.your + " upkeep there?",
        label: "Boarding Contribution",
        name: "contributeToRelatives",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        hides: {
            accommodationSituation: (v) => {
                return v!=="RELATIVES"
            }
        },
        model: "financial"
    }
}
export function monthlyAccommodationCosts(props) {
    return {
        name: "monthlyAccommodationCosts",
        label: "Accommodation Costs",
        text: "How much is " + props.you.your + " contribution per month?",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            accommodationSituation: (v) => {
                return v!=="RELATIVES"
            },
            contributeToRelatives: (v)=>{
                return v===false
            }
        },
        model: "financial"
    }
}
export function monthlyRentCosts(props) {
    return {
        name: "monthlyAccommodationCosts",
        label: "Accommodation Costs",
        text:  "How much is " + props.you.your + " rent per month?",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            accommodationSituation: (v) => {
                return v !== "RENTED"
            },
        },
        model: "financial"
    }
}
export function hasChildcareCosts(props) {

    return {
        label: "Has Child Minding Costs",
        text: capitaliseFirst(props.you.doYou) + " have any child-minding costs?",
        name: "hasChildcareCosts",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        hides: {
            countDependents: (v) => {
                return parseInt(v) === 0
            }
        },
        model: "financial"
    }
}
export function monthlyChildcareCosts(props) {
    return {
        label: "Child Minding Costs",
        text: "How much are " + props.you.your + " child-minding costs per month?",
        name: "monthlyChildcareCosts",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            countDependents: (v) => {
                return parseInt(v) === 0
            },
            hasChildcareCosts:(v)=>{
                return !v
            }
        },
        model: "financial"
    }
}
export function placeOfBirth(props) {
    return {
        label: "Place of Birth",
        name: "placeOfBirth",
        text: "What is " + props.you.your + " place of birth?",
        subtext: "supply county or city",
        answer: {
            type: "text"
        },
        model: "personal"
    }
}
personal.propTypes = {
    applicant: PropTypes.number
};